import { Reveal } from "./Reveal";
import { SERVICES } from "../../config";
import { ArrowUpRight } from "lucide-react";

const spans = [
  "lg:col-span-7",
  "lg:col-span-5",
  "lg:col-span-5",
  "lg:col-span-7",
  "lg:col-span-12",
];

export const Services = ({ onBook }) => (
  <section id="servicios" data-testid="services" className="relative z-10 py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <p className="overline mb-3">Qué hago</p>
        <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl max-w-2xl leading-[1.05]">
          Cinco categorías reales, no solo diseño bonito
        </h2>
        <p className="mt-5 text-zinc-400 max-w-xl">
          Cada proyecto resuelve un problema de negocio concreto. Elige el tipo de solución
          que necesitas.
        </p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-4">
        {SERVICES.map((s, i) => (
          <Reveal key={s.id} delay={i * 0.06} className={spans[i]}>
            <button
              onClick={onBook}
              data-testid={`service-${s.id}`}
              className="group text-left w-full h-full glass rounded-3xl p-8 hover-lift hover:border-[var(--magenta)]/40 transition-colors duration-300"
            >
              <div className="flex items-start justify-between">
                <span className="font-display text-5xl font-bold text-white/10 group-hover:text-[var(--magenta)]/40 transition-colors duration-300">
                  {s.n}
                </span>
                <ArrowUpRight className="text-zinc-600 group-hover:text-[var(--magenta)] transition-all duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </div>
              <h3 className="font-display font-semibold text-2xl mt-6">{s.title}</h3>
              <p className="mt-3 text-zinc-300">{s.solves}</p>
              <div className="mt-6 space-y-2 text-sm text-zinc-500">
                <p><span className="text-zinc-400">Para quién:</span> {s.who}</p>
                <p><span className="text-zinc-400">Qué entrego:</span> {s.delivers}</p>
              </div>
            </button>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
